module.exports = __webpack_public_path__ + "img/logo_navbar.70391bfa.png";